import React from "react";

/**
 * Customer column: the name from the shipping address, and under it
 * "city, province, country" (the province code, else its name; the country
 * name, else its code). Both are cut with … when long and show in full on
 * hover. Placeholders such as "NA" count as empty. Line 2 stays out until
 * get-orders returns these fields, so older backends show the name alone.
 */
// Placeholders some orders store instead of leaving a field empty.
const PLACEHOLDERS = new Set(["na", "n/a", "-", "--", "null", "undefined"]);

const clean = (value) => {
  const text = String(value ?? "").trim();
  return PLACEHOLDERS.has(text.toLowerCase()) ? "" : text;
};

const CustomerCell = ({ row }) => {
  const address = row?.order_shipping_address_details;
  const name = clean(address?.first_name);
  const place = [
    clean(address?.city),
    clean(address?.state) || clean(address?.state_name),
    clean(address?.country_name) || clean(address?.country),
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <div className="flex w-full min-w-0 flex-col gap-[2px]">
      <span title={name || undefined} className="min-w-0 truncate">
        {name || "-"}
      </span>
      {place && (
        <span
          title={place}
          className="min-w-0 truncate font-normal text-ui-text-subtle"
        >
          {place}
        </span>
      )}
    </div>
  );
};

export default CustomerCell;
